// extracted by mini-css-extract-plugin
export default {"container":"Card_container__n4uKW","flexEnd":"Card_flexEnd__zGSde"};